<template>
    <span v-if="robotList && robotList.length > 0">
        <span v-if="atBottom">
            <van-button
                        type="warning"
                        size="large"
                        style="width: 100%; border-radius: 0px"
                        @click="$emit('clickToJoin')"
            >加入助理
            </van-button>
        </span>
        <span v-else>
            <van-button v-if="join_robot_status" :icon="icon" plain size="small" type="danger" :style="{width: width}" @click="joinRobot">加入助理</van-button>
            <van-button v-else :icon="icon?'delete':''" size="small" type="danger" :style="{width: width}" @click="moveOutRobot">移出助理</van-button>
        </span>

        <van-popup v-model="show_dialog_for_robot" style="width: 90%;" round>
            <div style="text-align:center; font-size: 17px; font-weight: bold; padding: 15px 0px">提交内容到发品助理</div>
            <!--                    <van-divider style="padding: 0px; margin: 0px; border-color: #999999"></van-divider>-->
            <div style="padding: 0px 5px">
                <div style="text-align: center; border: 1px solid #77FFCC55; border-radius: 4px; padding: 5px; background-color: #77FFCC22">
                    左右滑动图片，选定要提交的图片
                </div>
            </div>

            <div style="padding-top: 5px">
                <div style="text-align: center" v-if="img_list && img_list.length > 0">
                    <!--                    <img :src="skuInfo.imageInfo.imageList[0].url" width="50%"/>-->
                    <van-swipe @change="onSwipeChange">
                        <van-swipe-item v-for="(image, index) in img_list" :key="index">
                            <Wp_image :url="image.img" :width="'40'"></Wp_image>

                        </van-swipe-item>
                        <div class="custom-indicator" slot="indicator">
                            {{ currentIndex + 1 }}/{{img_list.length}}
                        </div>
                    </van-swipe>
                </div>
                <div>
                    <van-field
                            v-model="link_content"
                            type="textarea"
                            readonly
                            autosize
                            style="font-size: 13px; line-height: 17px"
                    ></van-field>
                </div>
            </div>
            <!--                    <van-divider style="padding: 0px; margin: 0px; border-color: #999999"></van-divider>-->
            <div>
                <van-row>
                    <van-col span="12">
                        <van-button plain size="large"
                                    style="width: 100%; color: #555555; border-radius: 0px" @click="closePop"
                        >
                            取消
                        </van-button>
                    </van-col>
                    <van-col span="12">
                        <van-button plain size="large" style="width: 100%; color: #1989FA; border-radius: 0px"
                                    @click="submitToRobot"
                        >
                            确认提交
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </van-popup>
    </span>
</template>

<script>
    import {Dialog, Toast} from "vant";
    import Wp_image from "./Wp_image";

    export default {
        name: "Wp_join_robot_button_model",
        components: {Wp_image},
        props:{
            skuInfo: {type: Object, default: null},
            linkContent: {type: String, default: ""},
            robotList: {type: Array},
            imgList: {type: Array},
            width: {type: String, default: ''},
            icon: {type: String, default: ''},
            couponData:{type: Object},
            refresh: {type: String, default: ""},
            atBottom: {type: Boolean, default: false},
            // isCouponCanUse: {type: Boolean, default: true}
        },
        data(){
            return{
                //助理（机器人）列表
                // robotList:[],

                test_channel_name: "V006",
                channel_name: this.$store.state.username,

                //点击加入助理时弹出的内容展示
                show_dialog_for_robot: false,
                currentIndex: 0,
                //是否可以加入助理
                join_robot_status: true,
                //是否已推送
                is_pushed: false,

                sid: '',
                link_content: "",
                img_list: [],
                is_coupon_can_use: true,
            }
        },

        watch:{
            // linkContent(){
            //     if(this.skuInfo){
            //         this.sid = this.getSid();
            //         this.getPushStatus(this.skuInfo.skuId);
            //     }
            // },
            skuInfo(newInfo){
                // this.$log('----newInfo-----')
                this.$log(newInfo)
            },
            refresh(){
                // this.$log('----refresh-----')
                this.getPushStatus();
            }
        },

        created() {
            // this.getRobotList();
            if(this.skuInfo && this.robotList && this.robotList.length > 0){
                this.sid = this.getSid();
                this.getPushStatus();
            }

        },
        methods:{
            getSid(){
                if(this.sid){
                    return this.sid;
                }else{
                    if(this.skuInfo && this.skuInfo.skuId){
                        return this.$common.getSidToRobot(this.skuInfo.skuId);
                    }
                }
                return "";
            },
            getRobotList(){
                this.$getRobotList(list=>{
                    this.robotList = list;
                });
                // let params = {
                //     // channel_name: this.test_channel_name,
                //     channel_name: this.channel_name,
                // };
                //
                // this.$getRobotByChannelname(params, response=>{
                //     if(response && response.code == 200){
                //         this.robotList = response.data.list;
                //         // this.$emit("getRobotList", this.robotList)
                //     }
                // })
            },

            // joinRobotWithSkuInfo(skuInfo){
            //
            // },

            /**
             * 加入助理
             */
            joinRobot(){

                if(this.linkContent){
                    if(this.imgList && this.imgList.length > 0){
                        if(this.imgList[0].img){//如果是有img元素
                            this.img_list = this.imgList;
                        }else{
                            for(let i = 0; i < this.imgList.length; i++){
                                this.img_list.push({
                                    img: this.imgList[i].url
                                })
                            }
                        }
                    }else{
                        if(this.skuInfo){
                            for(let i = 0; i < this.skuInfo.imageInfo.imageList.length; i++){
                                this.img_list.push({
                                    img: this.skuInfo.imageInfo.imageList[i].url
                                })
                            }
                        }
                    }

                    this.link_content = this.linkContent;
                    this.joinRobot_with_content();
                }else{
                    if(this.skuInfo){
                        this.img_list = [];
                        for(let i = 0; i < this.skuInfo.imageInfo.imageList.length; i++){
                            this.img_list.push({
                                img: this.skuInfo.imageInfo.imageList[i].url
                            })
                        }
                        this.makeLinks(shortURL=>{
                            this.getLinkContent(shortURL);
                            this.joinRobot_with_content();
                        });
                    }
                }
                // if(this.is_coupon_can_use){
                //
                // }else{
                //     Dialog.alert({
                //         title: "提示",
                //         message: "当前群号" + this.channel_name + "所对应的群里没有配置助理，请联系客服进行助理配置"
                //     })
                // }
            },

            joinRobot_with_content(){
                //如果包含敏感词，则退出
                if(this.$common.hasSensitiveWords(this.link_content)){
                    return;
                }
                if(this.robotList && this.robotList.length > 0){
                    if(this.join_robot_status && !this.is_pushed){
                        this.show_dialog_for_robot = true;
                    }else{
                        Dialog.alert({
                            title: "提示",
                            message: "该商品今日已加入发品列表并已完成推送，不可再次加入助理，请明日再进行操作。或者自行使用'复制文案'和'分享图片'手动发品"
                        })
                    }
                }else{
                    Dialog.alert({
                        title: "提示",
                        message: "当前群号" + this.channel_name + "所对应的群里没有配置助理，请联系客服进行助理配置"
                    })
                }
            },

            /**
             * 移出助理（即删除助理发品列表中当前商品对应的数据）
             */
            moveOutRobot(){
                if(this.skuInfo){
                    let sid = this.getSid();
                    if(!this.join_robot_status){//移出助理状态
                        if(this.is_pushed){
                            //如果已推送，则不能删除
                            Dialog.alert({
                                title: "提示",
                                message: "当前商品已完成推送，不可进行移出操作",
                            })
                        }else{
                            //如果未推送，则可以删除
                            this.$log("可以删除")
                            let params = {
                                id: sid,
                            };
                            this.$deleteDataFromRobot(params, response=>{
                                this.$log(response)
                                if(response && response.code === 200){
                                    if(response.data && response.data.result && response.data.result === 'DELETED'){
                                        //删除成功
                                        this.join_robot_status = true;
                                        Toast.success({
                                            duration: 1000,
                                            message:"移出成功"
                                        });

                                        setTimeout(()=>{
                                            //必须要进行完成列表的查询，以保证再次进入详情时，可正确判断各种状态
                                            this.$getDataListFromRobot_All(data=>{
                                                this.$emit("getAllRobatSkuData", data)
                                            })
                                        }, 1500);
                                    }
                                }else{
                                    Toast.success({
                                        duration: 1000,
                                        message:"移出失败"
                                    });
                                }
                            })
                        }
                    }

                }

            },

            submitToRobot(){
                this.postContent();
                // this.join_robot_status = false;
                this.closePop();
            },

            /**
             * 提交商品内容到助理（机器人）
             */
            postContent(){
                if(this.skuInfo){
                    let post_img = this.skuInfo.imageInfo.imageList[this.currentIndex].url;
                    let params = this.$getPostToRobotData();
                    params.message_list[0].msgContent = post_img;
                    params.message_list[1].msgContent = this.link_content;
                    params.target_channel_name = this.channel_name;
                    // params.target_channel_name = this.test_channel_name;
                    params.id = this.getSid();
                    params.sku_id = this.skuInfo.skuId;

                    this.$postContentToRobot(params, response=>{
                        this.$log(response)
                        if(response && response.code === 200){
                            Toast.success({
                                duration: 1000,
                                message:"提交成功，已加入发品列表"
                            });
                            if(response.data && response.data.id){
                                //将“加入助理”按钮置为“移出助理”
                                this.join_robot_status = false;

                                //先同步+1，获取到完整数据后会替换
                                // this.$emit("updataBadegSync", 1);

                                setTimeout(()=>{
                                    //必须要进行完成列表的查询，以保证再次进入详情时，可正确判断各种状态
                                    this.$getDataListFromRobot_All(data=>{
                                        this.$emit("getAllRobatSkuData", data)
                                    })
                                }, 1500);
                            }
                        }else{
                            if(response && response.message){
                                Dialog.alert({
                                    message: response.message
                                })
                            }
                        }
                    })
                }
            },

            closePop(){
                this.show_dialog_for_robot = false;
            },

            /**
             * swipe滚动监听
             */
            onSwipeChange(index) {
                this.currentIndex = index;
            },

            /**
             * 获取当前商品的推送状态
             */
            getPushStatus(){
                let sid = this.getSid();

                if(this.$common.global_sku_all_data){
                    if(this.$common.global_sku_all_data.total > 0) {
                        let all_list = this.$common.global_sku_all_data.list;
                        for(let i = 0; i < all_list.length; i++){
                            if(all_list[i].id === sid){
                                if(all_list[i].task_status === 0){
                                    this.is_pushed = false;
                                    this.join_robot_status = false;
                                }else if(all_list[i].task_status === 1){
                                    this.is_pushed = true;
                                    this.join_robot_status = true;
                                }
                                this.$emit("getPushStatus", this.is_pushed);
                                return;
                            }
                        }
                        this.is_pushed = false;
                        this.join_robot_status = true;

                        this.$emit("getPushStatus", this.is_pushed);
                    }else{
                        this.is_pushed = false;
                        this.join_robot_status = true;

                        this.$emit("getPushStatus", this.is_pushed);
                    }
                }else{
                    // this.$getDataListFromRobot_All(response=>{
                    //     if(response){
                    //         this.$common.global_sku_all_data = response;
                    //         this.getPushStatus(_skuId);
                    //     }else{
                    //         this.is_pushed = false;
                    //     }
                    // });

                    if(!this.is_pushed){
                        this.join_robot_status = true;
                    }
                    this.$emit("getPushStatus", this.is_pushed);
                }
            },

            makeLinks(fn) {
                let _skuId = this.skuInfo.skuId;
                if (_skuId) {

                    let _data = this.getUrlParams(_skuId);

                    this.$getUnionLink(_data, response => {
                        let code = response.code;
                        // let message = response.message;
                        if (code === 200) {
                            this.is_coupon_can_use = true;
                            let shortURL = response.data.shortURL;
                            this.newLink = shortURL;
                            if (fn && typeof fn === 'function') {
                                fn(shortURL)
                            } else {
                                this.getLinkContent(shortURL);
                            }

                        } else{
                            this.is_coupon_can_use = false;
                            // Dialog.alert({
                            //     message: "添加失败，商品活动已过期"
                            // });
                            Toast({
                                duration: 1000,
                                message:"添加失败\n商品活动已过期"
                            })
                        }
                        // else if (code === 2001917) {
                        //     this.is_coupon_can_use = false;
                        //     Dialog.alert({
                        //         message: response.message
                        //     });
                        // }else if(code === 2001905){
                        //     this.is_coupon_can_use = false;
                        //     Dialog.alert({
                        //         message: response.message
                        //     });
                        // }
                    })
                }
            },

            getLinkContent(newLink) {
                // 评论数: 3W+
                // 好评率: 99%
                // 京东价: 209元
                // 优惠券: 30元
                // 内购价: 179元
                // 返利: 0.9元
                // 推广佣金: 1.2元
                // 入口: https://u.jd.com/9EcGZ6
                let content = '';
                // content += '【' + this.skuInfo.brandName + '】' + this.skuInfo.skuName + '\n';
                content += '【京东】' + this.skuInfo.skuName + '\n';
                content += '评论数: ' + this.skuInfo.comments + '  ';
                content += '好评率: ' + this.skuInfo.goodCommentsShare + '%' + '\n';
                content += '--------------------------' + '\n';

                if (this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice){
                    content += '京东价: ' + this.skuInfo.priceInfo.lowestPrice.toFixed(2) + '元(券' + (this.couponData.discount).toFixed(0) + '元)' + '\n';
                    content += '内购价: ' + (this.skuInfo.priceInfo.lowestCouponPrice).toFixed(2) + '元' + '\n';
                }else{
                    content += '京东价: ' + this.skuInfo.priceInfo.lowestPrice.toFixed(2) + '元' + '\n';
                }
                content += '抢购: ' + newLink + '\n';
                content += '--------------------------' + '\n';
                let second_host_url = this.$store.state.username + '.wapg.cn';
                content += '更多优惠: ' + second_host_url.toLowerCase();
                this.link_content = content;
            },
            getUrlParams(skuId) {
                let mediaId = this.$common.mediaId_70637;
                let _materialId = 'https://wqitem.jd.com/item/view?sku=' + skuId;
                let _couponUrl = '';
                if(this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice){
                    _couponUrl = this.couponData.link;
                }

                let _positionId = this.$common.getPid();
                //
                // if (this.position_id || this.$common.gloabl_wx_openid) {
                //     _positionId = this.position_id;
                // }

                // let _positionId = '1825325610';

                let _data = {
                    app_key: this.$common.getAppKeyInfo(mediaId).app_key,
                    app_secret: this.$common.getAppKeyInfo(mediaId).app_secret,
                    materialId: _materialId,
                    subUnionId: '',
                    positionId: _positionId, //推广位ID
                    // pid: _pid,
                    couponUrl: _couponUrl,
                    chainType: 2,
                };
                return _data;
            },
        }
    }
</script>

<style scoped>
    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 1px 7px;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.3);
    }
</style>